<template>
  <div class="fixed inset-0 flex items-center justify-center z-50">
    <div class="absolute inset-0 bg-black/50" @click="cancel"></div>
    <div class="bg-white rounded-lg shadow-lg p-6 z-10 w-full max-w-md">
      <h3 class="text-lg font-semibold mb-2">{{ title }}</h3>
      <p class="mb-4">{{ message }}</p>
      <div class="flex justify-end space-x-2">
        <button @click="cancel" class="btn-secondary">Cancel</button>
        <button @click="confirm" class="btn-danger">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ title?: string; message?: string }>()
const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()

const title = props.title || 'Confirm'
const message = props.message || 'Are you sure?'

function confirm() {
  emit('confirm')
}
function cancel() {
  emit('cancel')
}
</script>
